import { render } from "./XAccount.vue?vue&type=template&id=c373f4b0&scoped=true"
import script from "./XAccount.vue?vue&type=script&lang=js"
export * from "./XAccount.vue?vue&type=script&lang=js"

import "./XAccount.vue?vue&type=style&index=0&id=c373f4b0&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c373f4b0"]])

export default __exports__